"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.divide = exports.sum = exports.convert = exports.getSymbol = exports.SYMBOL_MAP = exports.getLabel = exports.LABEL_MAP_PLURAL = exports.LABEL_MAP_SINGULAR = exports.Energy = exports.KilowattHour = exports.UsEnergy = exports.UsBigCalorie = exports.SiEnergy = exports.Kilocalorie = exports.Calorie = exports.Kilojoule = exports.Joule = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
exports.NAMESPACE = 'Unit.Energy';
exports.Joule = effect_1.Schema.TaggedStruct('Joule', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.Joule` });
exports.Kilojoule = effect_1.Schema.TaggedStruct('Kilojoule', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.Kilojoule` });
exports.Calorie = effect_1.Schema.TaggedStruct('Calorie', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.Calorie` });
exports.Kilocalorie = effect_1.Schema.TaggedStruct('Kilocalorie', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.Kilocalorie` });
exports.SiEnergy = effect_1.Schema.Union(exports.Joule, exports.Kilojoule, exports.Calorie, exports.Kilocalorie).annotations({
    identifier: `${exports.NAMESPACE}.SiEnergy`,
});
exports.UsBigCalorie = effect_1.Schema.TaggedStruct('UsBigCalorie', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.UsBigCalorie` });
exports.UsEnergy = effect_1.Schema.Union(exports.Calorie, exports.UsBigCalorie).annotations({
    identifier: `${exports.NAMESPACE}.UsEnergy`,
});
exports.KilowattHour = effect_1.Schema.TaggedStruct('KilowattHour', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.KilowattHour` });
exports.Energy = effect_1.Schema.Union(...exports.SiEnergy.members, ...exports.UsEnergy.members, exports.KilowattHour).annotations({
    identifier: `${exports.NAMESPACE}.Energy`,
});
exports.LABEL_MAP_SINGULAR = {
    // SI
    Joule: 'joule',
    Kilojoule: 'kilojoule',
    Calorie: 'calorie',
    Kilocalorie: 'kilocalorie',
    // US
    UsBigCalorie: 'Calorie',
    // Neither
    KilowattHour: 'kilowatt-hour',
};
exports.LABEL_MAP_PLURAL = {
    // SI
    Joule: 'joules',
    Kilojoule: 'kilojoules',
    Calorie: 'calories',
    Kilocalorie: 'kilocalories',
    // US
    UsBigCalorie: 'Calories',
    // Neither
    KilowattHour: 'kilowatt-hours',
};
/**
 * Retrieves the label corresponding to a given {@link Energy}-tag
 */
const getLabel = (energy) => energy.amount === 1 ? exports.LABEL_MAP_SINGULAR[energy._tag] : exports.LABEL_MAP_PLURAL[energy._tag];
exports.getLabel = getLabel;
exports.SYMBOL_MAP = {
    // SI
    Joule: 'J',
    Kilojoule: 'kJ',
    Calorie: 'cal',
    Kilocalorie: 'kcal',
    // US
    UsBigCalorie: 'Cal',
    // Neither
    KilowattHour: 'kWh',
};
/**
 * Retrieves the symbol corresponding to a given {@link Energy}-tag
 */
const getSymbol = (tag) => exports.SYMBOL_MAP[tag];
exports.getSymbol = getSymbol;
/**
 * Ratio between {@link Joule} and other {@link Energy} unit of measure
 */
const FACTOR_MAP = {
    // SI
    Joule: 1,
    Kilojoule: 1_000,
    Calorie: 4.184,
    Kilocalorie: 4_184,
    // US
    UsBigCalorie: 4_184,
    // Neither
    KilowattHour: 3_600_000,
};
/**
 * Converts any {@link Energy} to a specific energy measure
 */
exports.convert = effect_1.Function.dual(2, (energy, outTag) => {
    const j = energy.amount * FACTOR_MAP[energy._tag];
    return {
        _tag: outTag,
        amount: j / FACTOR_MAP[outTag],
    };
});
/**
 * Sums {@link Energy} quantities and returns the result in the unit of measure of the 0th parameter
 */
const sum = (energy, ...args) => effect_1.Array.reduce(args, energy, (acc, energy) => ({
    ...acc,
    amount: acc.amount + (0, exports.convert)(energy, acc._tag).amount,
}));
exports.sum = sum;
const divide = (dividend, divisor) => ({
    ...dividend,
    amount: dividend.amount / (0, exports.convert)(divisor, dividend._tag).amount,
});
exports.divide = divide;
//# sourceMappingURL=energy.js.map